module.exports = __webpack_public_path__ + "img/background.d36d9a31.jpg";